import React from 'react';
import { FiArrowRight, FiMapPin } from 'react-icons/fi';
import Video from '../../videos/video.mp4';
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroInner,
  Eyebrow,
  EyebrowDot,
  HeroH1,
  Accent,
  HeroP,
  HeroBtns,
  HeroPrimary,
  HeroGhost,
  HeroMeta,
} from './HeroElements';

const linkProps = {
  smooth: true,
  duration: 500,
  spy: true,
  exact: 'true',
  offset: -72,
};

function HeroSection() {
  return (
    <HeroContainer id='home'>
      <HeroBg>
        <VideoBg playsInline autoPlay loop muted src={Video} type='video/mp4' />
      </HeroBg>
      <HeroInner>
        <Eyebrow>
          <EyebrowDot />
          Technology consulting &amp; product studio
        </Eyebrow>
        <HeroH1>
          We build software, and <Accent>ship our own products.</Accent>
        </HeroH1>
        <HeroP>
          Cloutch LLC partners with companies to design and build reliable
          software — and creates products of its own, like Repatch.
        </HeroP>
        <HeroBtns>
          <HeroPrimary to='services' {...linkProps}>
            What we do <FiArrowRight />
          </HeroPrimary>
          <HeroGhost to='products' {...linkProps}>
            See our products
          </HeroGhost>
        </HeroBtns>
        <HeroMeta>
          <FiMapPin /> Based in Atlanta, Georgia
        </HeroMeta>
      </HeroInner>
    </HeroContainer>
  );
}

export default HeroSection;
